import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d3a844"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "navigation",
  "aria-label": "main"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Customer Support")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Resell Your Ticket")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Ticket Your Event")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("About Oztix")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Terms & Conditions")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Privacy")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("FAQs")
const _hoisted_10 = {
  role: "navigation",
  "aria-label": "social"
}
const _hoisted_11 = ["tabindex"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Facebook ")
const _hoisted_13 = ["tabindex"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Twitter ")
const _hoisted_15 = ["tabindex"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Instagram ")
const _hoisted_17 = ["tabindex"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode("LinkedIn ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_button = _resolveComponent("menu-button")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_copyright = _resolveComponent("copyright")!
  const _component_focus_trap = _resolveComponent("focus-trap")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_menu_button, {
      ref: "menuButton",
      label: "Menu",
      "aria-haspopup": true,
      "aria-controls": "navigation",
      "aria-expanded": _ctx.isOpen,
      onClick: _ctx.openMenu
    }, null, 8, ["aria-expanded", "onClick"]),
    _createVNode(_component_focus_trap, {
      ref: "focusTrap",
      active: _ctx.isOpen,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpen) = $event)),
      "escape-deactivates": true,
      "allow-outside-click": false,
      onDeactivate: _ctx.closeMenu
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: "navigation",
          class: _normalizeClass(["nav-menu__container", { open: _ctx.isOpen }]),
          tabindex: "-1"
        }, [
          _createVNode(_component_close_button, {
            ref: "closeButton",
            label: "Close menu",
            class: "close-button",
            tabindex: _ctx.isOpen ? 0 : -1,
            onClick: _ctx.closeMenu
          }, null, 8, ["tabindex", "onClick"]),
          _createElementVNode("div", null, [
            _createElementVNode("nav", _hoisted_1, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/customer-support",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/resell-your-ticket",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/ticket-your-event",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.ticketYourEventClick
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/about",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/terms-and-conditions",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/privacy",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/frequently-asked-questions",
                    tabindex: _ctx.isOpen ? 0 : -1,
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["tabindex", "onClick"])
                ])
              ])
            ]),
            _createElementVNode("nav", _hoisted_10, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "https://www.facebook.com/Oztix/",
                    title: "Oztix Facebook Page",
                    target: "_blank",
                    tabindex: _ctx.isOpen ? 0 : -1
                  }, [
                    _hoisted_12,
                    _createVNode(_component_font_awesome_icon, { icon: ['fab', 'facebook'] })
                  ], 8, _hoisted_11)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "https://twitter.com/oztix",
                    title: "Oztix on Twitter",
                    target: "_blank",
                    tabindex: _ctx.isOpen ? 0 : -1
                  }, [
                    _hoisted_14,
                    _createVNode(_component_font_awesome_icon, { icon: ['fab', 'twitter'] })
                  ], 8, _hoisted_13)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "https://www.instagram.com/oztix/",
                    title: "Oztix on Instagram",
                    target: "_blank",
                    tabindex: _ctx.isOpen ? 0 : -1
                  }, [
                    _hoisted_16,
                    _createVNode(_component_font_awesome_icon, { icon: ['fab', 'instagram'] })
                  ], 8, _hoisted_15)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "https://www.linkedin.com/company/oztix",
                    title: "Oztix LinkedIn Company Page",
                    target: "_blank",
                    tabindex: _ctx.isOpen ? 0 : -1
                  }, [
                    _hoisted_18,
                    _createVNode(_component_font_awesome_icon, { icon: ['fab', 'linkedin'] })
                  ], 8, _hoisted_17)
                ])
              ])
            ])
          ]),
          _createVNode(_component_copyright, { align: "right" })
        ], 2)
      ]),
      _: 1
    }, 8, ["active", "onDeactivate"])
  ]))
}